import { combineReducers } from 'redux';

import modalReducer from './slices/modal';

const rootReducer = combineReducers({
    modals: modalReducer,
});

export default rootReducer;